import { Component } from 'vue-property-decorator'

import { dateToDisplay } from '@/utils/dateTime'
import { Breadcrumb } from '@/interfaces/breadcrumbs'
import PoliciesList from '@/modules/Policy/scripts/policies-list'

@Component({})
export default class RelatedPoliciesList extends PoliciesList {
  breadcrumbs: Breadcrumb[] = []

  caseId: number | null = null
  quoteId: number | null = null
  accountId: number | null = null
  contactId: number | null = null
  relatedcarrierProductId: number | null = null
  producerId: number | null = null

  pageType = ''

  ifRelatedList = true

  beforeMount () {
    this.setBreadcrumbs()
    this.filter = {
      caseId: this.caseId,
      contactId: this.contactId,
      accountId: this.accountId,
      relatedcarrierProductId: this.relatedcarrierProductId,
      producerId: this.producerId,
      quoteId: this.quoteId,
      isCaseRelated: this.pageType === 'relatedPolicy'
    }
    this.storePage()
  }

  async mounted () {
    this.pageType = this.$route.params.type
  }

  setBreadcrumbs () {
    const { fromName, id } = this.$route.params
    switch (this.$route.name) {
      case 'AccountRelatedPoliciesList':
        this.accountId = Number(id)
        this.breadcrumbs.push(
          {
            text: 'Accounts',
            to: { name: 'AccountsList' }
          }
        )
        this.breadcrumbs.push({
          text: fromName || id,
          to: {
            name: 'AccountDetailPolicy',
            params: {
              id: id
            }
          }
        })
        break
      case 'CaseRelatedPoliciesList':
        this.caseId = Number(id)
        this.breadcrumbs.push(
          {
            text: 'Case',
            to: { name: 'CaseDashboard' }
          }
        )
        this.breadcrumbs.push({
          text: fromName
            ? `${fromName} (Case ID: ${id})`
            : id,
          to: {
            name: 'CaseDetailPolicies',
            params: {
              id: id
            }
          }
        })
        break
      case 'ContactRelatedPoliciesList':
        this.contactId = Number(id)
        this.breadcrumbs.push(
          {
            text: 'Contacts',
            to: { name: 'ContactList' }
          }
        )
        this.breadcrumbs.push({
          text: fromName || id,
          to: {
            name: 'ContactDetailPolicies',
            params: {
              id: id
            }
          }
        })
        break
      case 'QuoteRelatedPoliciesList':
        this.quoteId = Number(id)
        this.breadcrumbs.push(
          {
            text: 'Quotes',
            to: { name: 'QuotesList' }
          }
        )
        this.breadcrumbs.push({
          text: fromName || id,
          to: {
            name: 'QuoteDetailRelated',
            params: {
              id: id
            }
          }
        })
        break
      case 'CarrierProductRelatedPoliciesList':
        this.relatedcarrierProductId = Number(id)
        this.breadcrumbs.push(
          {
            text: 'Insurance Products',
            to: { name: 'CarrierProductList' }
          }
        )
        this.breadcrumbs.push({
          text: fromName || id,
          to: {
            name: 'CarrierProductDetailPolicies',
            params: {
              id: id
            }
          }
        })
        break
      case 'ProducerRelatedPoliciesList':
        this.producerId = Number(id)
        this.breadcrumbs.push(
          {
            text: 'Producers',
            to: { name: 'ProducerList' }
          }
        )
        this.breadcrumbs.push({
          text: fromName || id,
          to: {
            name: 'ProducerDetailPolicies',
            params: {
              id: id
            }
          }
        })
        break
      default:
        break
    }
    this.breadcrumbs.push({
      text: 'policies'
    })
  }
}
